import { useParams, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import PageHeader from '../../components/layout/PageHeader';
import Tabs from '../../components/ui/Tabs';
import { FullScreenSpinner } from '../../components/ui/Spinner';
import EmptyState from '../../components/ui/EmptyState';
import Badge from '../../components/ui/Badge';
import { getUser } from '../../api/users';
import ProfileTab from './tabs/ProfileTab';
import RolesTab from './tabs/RolesTab';
import PermissionsTab from './tabs/PermissionsTab';

const TABS = [
  { value: 'profile', label: 'Profile' },
  { value: 'roles', label: 'Roles' },
  { value: 'permissions', label: 'Permissions' },
];

export default function UserDetail() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'profile';

  const userQuery = useQuery({ queryKey: ['users', id], queryFn: () => getUser(id) });

  if (userQuery.isLoading) return <FullScreenSpinner />;
  if (userQuery.isError) return <EmptyState title="User not found" />;

  const user = userQuery.data;

  return (
    <div>
      <PageHeader
        title={user.name}
        description={user.email}
        actions={
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
              user.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-600'
            }`}
          >
            {user.is_active ? 'Active' : 'Inactive'}
          </span>
        }
      />

      <div className="mb-4 flex flex-wrap gap-1.5">
        {user.roles.map((r) => (
          <Badge key={r}>{r}</Badge>
        ))}
      </div>

      <Tabs tabs={TABS} active={activeTab} onChange={(tab) => setSearchParams({ tab })} />

      <div className="mt-6">
        {activeTab === 'profile' && <ProfileTab user={user} />}
        {activeTab === 'roles' && <RolesTab user={user} />}
        {activeTab === 'permissions' && <PermissionsTab user={user} />}
      </div>
    </div>
  );
}
